module.exports = __webpack_public_path__ + "static/img/sex-2.f4471e66.png";